import { render } from "./FooterLayout.vue?vue&type=template&id=d144c832"
import script from "./FooterLayout.vue?vue&type=script&lang=js"
export * from "./FooterLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__